import { jsx as r, jsxs as e } from "react/jsx-runtime";
import { Icon as o } from "../Icon/index.js";
import { BannerContentContainer as B, BannerContent as m, BannerCaption as h, BannerCloseButton as E, BannerContainerSuccess as R, BannerContainerError as S, BannerContainerAlert as p, BannerContainerDefault as x, BannerContainerInfo as A } from "./style.js";
import { Xmark as j } from "@pelando/fontawesome/icons";
var k = /* @__PURE__ */ ((n) => (n.DEFAULT = "default", n.SUCCESS = "success", n.ERROR = "error", n.ALERT = "alert", n.INFO = "info", n))(k || {});
const D = {
  success: R,
  error: S,
  alert: p,
  default: x,
  info: A
}, b = ({
  caption: n,
  title: t,
  className: c,
  leftIcon: a,
  rightIcon: i,
  onClick: s,
  onClose: l,
  bannerType: C = "default",
  ...d
}) => {
  const f = () => /* @__PURE__ */ e(B, { children: [
    /* @__PURE__ */ e(m, { children: [
      a && /* @__PURE__ */ r(o, { icon: a }),
      /* @__PURE__ */ e(h, { children: [
        t && /* @__PURE__ */ e("b", { children: [
          t,
          " "
        ] }),
        n
      ] })
    ] }),
    i ? /* @__PURE__ */ r(o, { icon: i }) : /* @__PURE__ */ r(E, { onClick: l, children: /* @__PURE__ */ r(o, { icon: j }) })
  ] }), u = D[C];
  return /* @__PURE__ */ r(u, { className: c, ...d, onClick: s, children: f() });
};
export {
  b as Banner,
  k as BannerType
};
